// Edit this list to change the live call times. Past sessions hide automatically.
export const SESSIONS = [
  { id: "2026-11-04-6pm", label: "wednesday, november 4 at 6pm pacific", start: "2026-11-04T18:00:00-08:00" },
  { id: "2026-11-06-11am", label: "friday, november 6 at 11am pacific", start: "2026-11-06T11:00:00-08:00" },
];

export const SHOW_BONUS_BAND = false;

export const SESSION_MINUTES = 30;

export const upcomingSessions = () => SESSIONS.filter((s) => new Date(s.start).getTime() > Date.now());

export const BUILT_STORAGE_KEY = 'built_signup';
